
let common = {
  //网路请求封装
  requestFun(thisObj, type, url, data, callback,error) {
    let requestData = type == 'get' ? {
      method: type,
      url: url,
      params: data
    } : {
        method: type,
        url: url,
        data: thisObj.qs.stringify(data)
      };
    thisObj.$axios(requestData).then(
      res => {
        if (res) {
            return callback(res);
        }
      }).catch( err => {
        thisObj.$message({
          message: "网络错误",
          type: "error",
          center: true
        });
        error && error();
      }
    )
      /*捕获异常*/
      .catch(function (err) {
        thisObj.$message({
          message: "网络错误",
          type: "error",
          center: true
        });
        error && error();
      });
  }
};
export {
  common
};
